import { RewardPolicyResponse } from '@models/item';
import { OrderLine, OrderOption } from '@models/order';

export function makeItemKey(item: OrderLine): string {
    const options = item
        ? [...item.defaultOptions, ...item.personalOptions]
            .map((it) => it.options)
            .flat() : undefined;
    // 옵션 순서가 클라이언트와 서버 간에 다를 수 있으므로 정렬하여 동일 키 보장
    const optionKey = options
        ?.map((it) => `${it.posId}x${it.quantity}`)
        .sort()
        .join(':');

    return [item?.posId, optionKey]
        .filter((it) => !!it)
        .join(':');
}

/**
 * 적립 정책을 주문 상품·옵션(OrderLine·OrderOption)의 로컬 적립 필드로 변환.
 * 상품과 옵션 모두 자기 rewardPolicy 만으로 적립량이 결정되고, 서로의 적립을 막지 않는다.
 * rewardType 이 NONE 이면 그 대상만 적립하지 않는다.
 */
export function toReward(
    rewardPolicy?: RewardPolicyResponse,
): Pick<OrderLine & OrderOption, 'rewardType' | 'rewardAmount'> {
    return {
        rewardType: rewardPolicy?.rewardType ?? 'NONE',
        rewardAmount: rewardPolicy?.rewardAmount ?? 0,
    };
}
